import { create } from "zustand";
export interface Coordinates {
	lng: number;
	lat: number;
}

export interface MapViewState {
	longitude: number;
	latitude: number;
	zoom: number;
	bearing: number;
	pitch: number;
}

interface MapState {
	mapLatitude: number | null;
	mapLongitude: number | null;
	mapZoom: number | null;
	setMapLatitude: (lat: number) => void;
	setMapLongitude: (lng: number) => void;
	setMapZoom: (zoom: number) => void;
	setCoordinates: (lat: number, lng: number) => void;
	setMapState: (lat: number, lng: number, zoom: number) => void;
	showProperty: boolean;
	setShowProperty: (updater: (showProperty: boolean) => boolean) => void;
	handleNavigate: boolean;
	setHandleNavigate: (updater: (handleNavigate: boolean) => boolean) => void;
	passListingId: string;
	setPassListingId: (passListingId: string) => void;
	showSlider: boolean;
	setShowSlider: (showSlider: boolean) => void;
	fullWidthProperty: boolean;
	setFullWidthProperty: (fullWidthProperty: boolean) => void;
	coordinatesLatLng: Coordinates[];
	setCoordinatesLatLng: (coordinatesLatLng: Coordinates[]) => void;
	lastKnownLocation: Coordinates[];
	setLastKnownLocation: (lastKnownLocation: Coordinates[]) => void;
	limitMap: number;
	setLimitMap: (limit: number) => void;
}

export const useMapStore = create<MapState>((set) => ({
	limitMap: 500,
	setLimitMap: (limit: number) => set({ limitMap: limit }),
	fullWidthProperty: false,
	setFullWidthProperty: (show) => set({ fullWidthProperty: show }),
	showSlider: false,
	setShowSlider: (show) => set({ showSlider: show }),
	passListingId: "",
	setPassListingId: (id) => set({ passListingId: id }),
	mapLatitude: null,
	mapLongitude: null,
	mapZoom: null,
	setMapLatitude: (lat) => set({ mapLatitude: lat }),
	setMapLongitude: (lng) => set({ mapLongitude: lng }),
	setMapZoom: (zoom) => set({ mapZoom: zoom }),
	setCoordinates: (lat, lng) => set({ mapLatitude: lat, mapLongitude: lng }),
	setMapState: (lat, lng, zoom) =>
		set({ mapLatitude: lat, mapLongitude: lng, mapZoom: zoom }),
	showProperty: false,
	setShowProperty: (updater: (prev: boolean) => boolean) =>
		set((state) => ({
			showProperty: updater(state.showProperty),
		})),
	handleNavigate: true,
	setHandleNavigate: (updater: (prev: boolean) => boolean) =>
		set((state) => ({
			handleNavigate: updater(state.handleNavigate),
		})),
	coordinatesLatLng: [],
	setCoordinatesLatLng: (coordinates) =>
		set({ coordinatesLatLng: coordinates }),
	lastKnownLocation: [{ lng: -79.4163, lat: 43.70011 }],
	setLastKnownLocation: (state) => set({ lastKnownLocation: state }),
}));
